import { ref, type Ref } from 'vue'

const THRESHOLD_PX = 20

/**
 * Tracks whether a scrollable element has been scrolled to its end, for gating an action behind
 * reading the whole content. Content that fits without scrolling counts as read.
 *
 * Call `check` from the element's scroll handler and again once its content renders;
 * `reset` returns to the unread state.
 */
export const useScrolledToBottom = (container: Readonly<Ref<HTMLElement | null>>) => {
  const hasScrolledToBottom = ref(false)

  const check = (): void => {
    const element = container.value
    if (element === null) return

    hasScrolledToBottom.value =
      element.scrollTop + element.clientHeight >= element.scrollHeight - THRESHOLD_PX
  }

  const reset = (): void => {
    hasScrolledToBottom.value = false
  }

  return { check, hasScrolledToBottom, reset }
}
